<!--
This component can be used when you get a strange vuetify error when putting `v-icon` into `VueDatePicker`, like example below:
```
<template #arrow-left>
  <v-icon icon="mdi-chevron-left"></v-icon>
</template>
```
[Vue warn]: injection "Symbol(vuetify:defaults)" not found
Error: [Vuetify] Could not find defaults instance
-->

<script setup lang="ts">
export interface Props {
  icon: string;
}
const props = withDefaults(defineProps<Props>(), {});
</script>

<template>
  <i
    :class="[props.icon, 'mdi v-icon v-icon--size-default']"
    data-testid="fallbackMdiIconCmn"
    aria-hidden="true"
  >
  </i>
</template>
